<section>
  <div flex fxLayout="column" fxLayoutAlign="center"></div>
</section>

<div>
  <p>Bitte wählen Sie den neuen Status für die Anschlussänderung aus und geben Sie einen Kommentar ein.</p>
</div>

<form [formGroup]="currentForm">
  <section fxLayout="column" fxLayoutAlign="start">
    <div class="wrapper">
      <div class="col" fxFlex="100">
        <mat-form-field appearance="outline">
          <mat-label>Neuer Status</mat-label>
          <mat-select [formControl]="currentForm.controls.newState">
            <mat-option *ngFor="let option of connectionChangeStatusOptions" [value]="option">
              {{ ConnectionChangeRequestStatusDisplayNames[option] || '[Fehler: Unbekannter Status]' }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </section>
</form>

<div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
  <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
  <button
    mat-raised-button
    color="primary"
    id="modal-confirm-after-meter-change"
    (click)="confirm(currentForm)">
    <span>Status ändern</span>
  </button>
</div>
